import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FaGlobe } from 'react-icons/fa';

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-md);
  background: transparent;
  border: 1px solid var(--secondary-300);
  border-radius: var(--radius-md);
  color: var(--secondary-700);
  cursor: pointer;
  transition: all var(--transition-normal);
  
  &:hover {
    background: var(--secondary-50);
    border-color: var(--primary-600);
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: var(--space-xs);
  background: white;
  border: 1px solid var(--secondary-300);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  min-width: 150px;
  z-index: 1000;
  overflow: hidden;
`;

const Option = styled.button`
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  text-align: left;
  background: white;
  border: none;
  cursor: pointer;
  transition: background var(--transition-fast);
  
  &:hover {
    background: var(--secondary-50);
  }
  
  ${props => props.$active && `
    background: var(--primary-50);
    color: var(--primary-700);
    font-weight: 600;
  `}
`;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <Container>
      <Button onClick={() => setIsOpen(!isOpen)}>
        <FaGlobe />
        {currentLanguage.name}
      </Button>
      {isOpen && (
        <Dropdown>
          {languages.map(lang => (
            <Option
              key={lang.code}
              $active={lang.code === i18n.language}
              onClick={() => changeLanguage(lang.code)}
            >
              {lang.name}
            </Option>
          ))}
        </Dropdown>
      )}
    </Container>
  );
};

export default LanguageSwitcher;

